import React from 'react'
import MaterialSymbol from '../material-symbol'

const ArrowBackIos = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="arrow_back_ios" {...props} />
))

ArrowBackIos.displayName = 'ArrowBackIos'

export default ArrowBackIos
